module.exports = __webpack_public_path__ + "static/img/paatlogo.06c48e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/banner/paatlogo.jpg
// module id = CRTy
// module chunks = 41